import { Cell } from 'reducers/subscription/user'
import { Answer, Filter } from 'typings/filters'

export type FilterCombination = Filter & { categoryName?: string }

export const generateCombinationSet = (
  productArray: FilterCombination[],
  marketArray: FilterCombination[]
) => {
  const combinationSet = []

  for (const productItem of productArray) {
    for (const marketItem of marketArray) {
      combinationSet.push({
        product_code: productItem.categoryName,
        market_code: marketItem.categoryName,
      })
    }
  }

  return combinationSet
}

export const filterContext = (
  sharedContextArray: Cell[],
  combArray: {
    product_code?: string
    market_code?: string
  }[]
) => {
  if (!sharedContextArray.length) {
    return combArray.map(({ product_code, market_code }) => ({
      itemGroup: product_code,
      country: market_code,
    }))
  }
  const filteredSharedContext = sharedContextArray.filter((contextItem) => {
    return combArray.some((combItem) => {
      return (
        contextItem.country === combItem.market_code &&
        contextItem.itemGroup === combItem.product_code
      )
    })
  })

  const filteredSharedContextWithoutWaves = filteredSharedContext.map(
    ({ waves, ...rest }: Cell) => rest
  )

  return filteredSharedContextWithoutWaves
}

export const mapFiltersWithValues = (
  filters: Filter[],
  variableId: number,
  valuesData: Answer[]
) => {
  return filters
    .filter((filter) => filter.variable_id === variableId)
    .map((filter) => {
      return {
        ...filter,
        categoryName: valuesData?.find((answer) => filter.answer_code === answer.answer_code)
          ?.category_name,
      }
    })
}

export const isValidContext = (
  sharedContextArray: Omit<Cell, 'waves'>[],
  loggedInUserContext: Omit<Cell, 'waves'>[]
) => {
  if (loggedInUserContext?.length === 0) {
    return true
  }
  if (!sharedContextArray.length) {
    return false
  }
  return sharedContextArray.every((sharedContext) => {
    return loggedInUserContext.some((contextItem) => {
      return (
        sharedContext.country === contextItem.country &&
        sharedContext.itemGroup === contextItem.itemGroup
      )
    })
  })
}

export const hasMatch = (
  combArray: {
    product_code?: string
    market_code?: string
  }[],
  context: Cell[]
) => {
  if (context && context.length === 0) return true
  return combArray.every((combItem) =>
    context.some(
      (contextItem) =>
        contextItem.itemGroup === combItem.product_code &&
        contextItem.country === combItem.market_code
    )
  )
}
